import React from "react";
import { Box, Paper, Typography } from "@mui/material";

interface EarningsStatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  highlighted?: boolean;
  valueColor?: string;
}

const EarningsStatCard: React.FC<EarningsStatCardProps> = ({
  title,
  value,
  subtitle,
  icon,
  highlighted = false,
  valueColor,
}) => {
  return (
    <Paper
      elevation={highlighted ? 4 : 1}
      sx={{
        p: 3,
        height: "100%",
        background: highlighted
          ? "linear-gradient(135deg, #178B8E 0%, #0F6164 100%)"
          : "#FFFFFF",
        color: highlighted ? "white" : "text.primary",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: highlighted ? 6 : 3,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 2,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: highlighted ? "rgba(255, 255, 255, 0.9)" : "text.secondary",
          }}
        >
          {title}
        </Typography>
        {icon && (
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 2,
              backgroundColor: highlighted
                ? "rgba(255, 255, 255, 0.2)"
                : "rgba(23, 139, 142, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {icon}
          </Box>
        )}
      </Box>

      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          mb: subtitle ? 1 : 0,
          color: valueColor || (highlighted ? "white" : "text.primary"),
        }}
      >
        {value}
      </Typography>

      {subtitle && (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            color: highlighted ? "rgba(255, 255, 255, 0.8)" : "text.secondary",
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Paper>
  );
};

export default EarningsStatCard;
